import { Card } from "../../../components/ui/card";
import { formatCOP } from "../../../lib/api";

export const MarcasTab = ({ items, total }) => {
  if (!items.length) {
    return (
      <Card className="p-12 text-center bg-white border-cm-border shadow-none">
        <p className="text-sm text-cm-ink-soft">Sin marcas vendidas en este período.</p>
      </Card>
    );
  }
  const max = Math.max(1, ...items.map((m) => m.total));
  return (
    <Card className="bg-white border-cm-border shadow-none overflow-hidden" data-testid="marcas-list">
      <table className="w-full text-sm">
        <thead className="text-left text-[10px] uppercase tracking-widest text-cm-ink-soft bg-cm-cream-alt/40">
          <tr><th className="px-5 py-2.5">#</th><th className="px-2 py-2.5">Marca</th><th className="px-2 py-2.5 text-right">Pedidos</th><th className="px-2 py-2.5 text-right">Unidades</th><th className="px-2 py-2.5">Participación</th><th className="px-5 py-2.5 text-right">Total</th></tr>
        </thead>
        <tbody className="divide-y divide-cm-border">
          {items.map((m, i) => {
            const pct = total ? (m.total / total) * 100 : 0;
            const barPct = (m.total / max) * 100;
            return (
              <tr key={m.marca} className="hover:bg-cm-cream-alt/30" data-testid={`marca-row-${i + 1}`}>
                <td className="px-5 py-3 font-mono text-cm-ink-soft text-xs">{i + 1}</td>
                <td className="px-2 py-3 font-medium">{m.marca}</td>
                <td className="px-2 py-3 text-right font-mono text-xs text-cm-ink-soft">{m.pedidos}</td>
                <td className="px-2 py-3 text-right font-mono text-xs">{m.cantidad.toFixed(0)}</td>
                <td className="px-2 py-3 w-48">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 h-1.5 bg-cm-cream-alt rounded-full overflow-hidden">
                      <div className="h-full bg-cm-red" style={{ width: `${barPct}%` }} />
                    </div>
                    <span className="text-[10px] text-cm-ink-soft font-mono">{pct.toFixed(1)}%</span>
                  </div>
                </td>
                <td className="px-5 py-3 text-right font-mono font-semibold">{formatCOP(m.total)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Card>
  );
};

export const ProductosTab = ({ items }) => {
  if (!items.length) {
    return (
      <Card className="p-12 text-center bg-white border-cm-border shadow-none">
        <p className="text-sm text-cm-ink-soft">Sin productos vendidos en este período.</p>
      </Card>
    );
  }
  return (
    <Card className="bg-white border-cm-border shadow-none overflow-hidden" data-testid="productos-list">
      <table className="w-full text-sm">
        <thead className="text-left text-[10px] uppercase tracking-widest text-cm-ink-soft bg-cm-cream-alt/40">
          <tr><th className="px-5 py-2.5">#</th><th className="px-2 py-2.5">Producto</th><th className="px-2 py-2.5">Marca</th><th className="px-2 py-2.5 text-right">Pedidos</th><th className="px-2 py-2.5 text-right">Unidades</th><th className="px-5 py-2.5 text-right">Total</th></tr>
        </thead>
        <tbody className="divide-y divide-cm-border">
          {items.map((p, i) => (
            <tr key={p.producto_id || i} className="hover:bg-cm-cream-alt/30" data-testid={`producto-row-${i + 1}`}>
              <td className="px-5 py-3 font-mono text-cm-ink-soft text-xs">{i + 1}</td>
              <td className="px-2 py-3">
                <div className="font-medium truncate max-w-[280px]">{p.nombre}</div>
                <div className="text-[11px] text-cm-ink-soft font-mono">#{p.producto_id}</div>
              </td>
              <td className="px-2 py-3 text-xs">{p.marca || "—"}</td>
              <td className="px-2 py-3 text-right font-mono text-xs text-cm-ink-soft">{p.pedidos}</td>
              <td className="px-2 py-3 text-right font-mono text-xs">{p.cantidad.toFixed(0)}</td>
              <td className="px-5 py-3 text-right font-mono font-semibold">{formatCOP(p.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
};
